module.exports = __webpack_public_path__ + "img/vertical_7_7_9016.d18f0339.png";